import React from 'react';
import { Copywriting, GetMsgResCode, TRACKING_MSG_TYPE, TRACKING_OPERATION, EPOD_ERROR_MESSAGE, TRACKING_TARGET, TRACKING_TYPE } from '@/utils/constants';
import { addObserver, removeObserver } from '@/utils/intersectionObserver';
import { inject, observer } from 'mobx-react';
import { openFullScreenImage, handleImageUpload, showOverSizeToast } from '@/utils/tools';
import { AgentUploadLoading } from '@/components/Common/Loader';
import { UploadFileStatus } from '@/stores/agent';
import { dispatchTrack } from '@/utils/tracking';
import { postChatMsg } from '@/utils/agent';
import { getChildInject, getTrans } from '@/utils/instantLoaded/tools';

import imageFailure from '@/assets/img/image_failure.svg';
import clsx from 'classnames';

import reporter from '@/utils/report';
import './index.scss';

export interface ImageProps {
  imgBlobUrl?: string;
  /** 发送消息成功时，设置图片链接 */
  imgUrl?: string;
  /** 图片上传成功时，缓存图片链接 */
  _imgUrl?: string;
  loading?: boolean;
  curPos?: number;
  image?: string;
  size?: number;
  agentStore?: any;
  isEpod: boolean,
  /** 发送消息是否失败 */
  sendMsgError?: boolean;
  initStore: any;
  from: string;
}
interface state {
  isOnLoading: boolean,
  canLoadEpod: boolean,
}
@inject(getChildInject('initStore', 'agentStore'))
@observer
export default class Image extends React.Component<ImageProps, state> {

  imageRef = React.createRef<HTMLImageElement>();
  trackingname = TRACKING_TYPE.IMAGE;
  trackingdata = {};

  constructor(props: ImageProps) {
    super(props);

    this.trackingdata = {
      chat_session_id: this.props.initStore.sessionId,
      if_history: TRACKING_MSG_TYPE.REAL_TIME,
      is_sender: this.props.from === 'user' ? 'true' : 'false',
    };
    this.state = { isOnLoading: true, canLoadEpod: false };
  }


  async componentDidMount() {
    const {
      imgUrl = '',
      isEpod = false,
    } = this.props;
    if (isEpod) {

      const img = document.createElement('img');
      img.src = imgUrl;
      const _this = this;
      img.onload = () => {
        _this.setState({ canLoadEpod: true, isOnLoading: false });
      };
      img.onerror = () => {
        _this.setState({ canLoadEpod: false, isOnLoading: false });
      };
    }

  }

  handleImgLoad = () => {
    const {
      imgBlobUrl = '',
      imgUrl = '',
    } = this.props;

    if (imgUrl) {
      addObserver(this.imageRef.current);
      return;
    } else if (imgBlobUrl) {
      window.URL.revokeObjectURL(imgBlobUrl);
    }
  };

  handleImgClick = () => {
    const { imgUrl = '' } = this.props;

    // 没上传成功的，无法查看大图
    if (!imgUrl) {
      return;
    }

    dispatchTrack({
      operation: TRACKING_OPERATION.CLICK,
      // @ts-ignore
      target: TRACKING_TARGET[this.trackingname],
      data: {
        ...this.trackingdata,
        image_id: imgUrl,
      },
    });
    openFullScreenImage(imgUrl);
  };

  componentWillUnmount() {
    removeObserver(this.imageRef.current);
  }

  handleStatusClick = () => {
    const {
      image = '',
      imgUrl = '', // 消息发送成功时才有值
      _imgUrl = '', // 图片上传成功时就有值
      curPos,
      size,
      agentStore,
      sendMsgError,
    } = this.props;

    if (size && size > agentStore.maxImageSize) {
      showOverSizeToast(Copywriting.IMAGE_UPLOAD_OVERSIZE, { size: agentStore.maxImageSize / 1024 / 1024 });
    }

    if (!imgUrl && !_imgUrl) {
      // 上传失败，重发
      handleImageUpload(image, curPos, true);
    }

    if (sendMsgError) {
      agentStore.UPDATE_FILE_UPLOADING_COUNT(UploadFileStatus.UPLOADING);

      // 点击先去掉叹号
      agentStore.UPDATE_AGENT_DATA_ITEM({ loading: true }, curPos);
      // 用户主动重发数
      reporter.apiBatchReport({ type: 'count', value: { label: 'channel_chat_message_user_resend_total' }});
      postChatMsg({
        type: 'IMG',
        text: _imgUrl,
        params: {
          thumbnail: _imgUrl,
          url: _imgUrl,
        },
      }).then(({ code }) => {
        if (code === GetMsgResCode.SUCCESS) {
          agentStore.UPDATE_AGENT_DATA_ITEM(
            { imgUrl: _imgUrl },
            curPos,
          );
        }

        agentStore.UPDATE_FILE_UPLOADING_COUNT(UploadFileStatus.UPLOADED);
        agentStore.UPDATE_AGENT_DATA_ITEM(
          {
            sendMsgError: code !== GetMsgResCode.SUCCESS,
            loading: false,
          },
          curPos,
        );
      });
    }
  };
  handleError = (eee: any) => {
    console.log(eee);
  };
  render() {
    const {
      imgBlobUrl = '',
      imgUrl = '',
      _imgUrl = '',
      loading,
      isEpod = false,
      sendMsgError,
      from,
    } = this.props;

    const { isOnLoading, canLoadEpod } = this.state;

    return (
      <div className={clsx('image-wrapper', { reverse: from === 'bot' })}>
        {
          loading
            ? <AgentUploadLoading />
            : <div className="status-icon" onClick={this.handleStatusClick} >
              {((!imgUrl && !_imgUrl) || sendMsgError) && <img src={imageFailure} />}
            </div>
        }
        {
          // epod 展示图片
          !isOnLoading && canLoadEpod && <div className="image-wrapper__content">
            <img
              ref={this.imageRef}
              data-trackingname={this.trackingname}
              data-trackingdata={JSON.stringify({
                ...this.trackingdata,
                image_id: imgUrl,
              })}
              onError={this.handleError}
              onLoad={this.handleImgLoad}
              src={imgUrl || _imgUrl || imgBlobUrl}
              onClick={this.handleImgClick}
            />
          </div>
        }

        {
          !isOnLoading && !canLoadEpod && <p className="msg"> {getTrans(EPOD_ERROR_MESSAGE) || 'epod load Error'} </p>
        }

        {
          // 正常展示图片
          !isEpod
          && <div className="image-wrapper__content">
            <img
              ref={this.imageRef}
              data-trackingname={this.trackingname}
              data-trackingdata={JSON.stringify({
                ...this.trackingdata,
                image_id: imgUrl,
              })}
              onError={this.handleError}
              onLoad={this.handleImgLoad}
              src={imgUrl || _imgUrl || imgBlobUrl}
              onClick={this.handleImgClick}
            />
          </div>
        }

      </div >
    );
  }
}
